up.compiler('[data-highlight]', { priority: 10 }, (element: HTMLElement) => {
  const targets = Array.from(
    document.querySelectorAll<HTMLElement>(element.getAttribute('data-highlight')!),
  )

  for (const target of targets) {
    target.classList.add('-highlighted')
  }

  return () => {
    for (const target of targets) {
      target.classList.remove('-highlighted')
    }
  }
})
